import type { Track } from '../api.js';
import StateBadge from './StateBadge.js';
import RepoBadge from './RepoBadge.js';
import PrereqBlock from './PrereqBlock.js';
import ManifestBlock from './ManifestBlock.js';

interface Props {
  track: Track;
}

export default function ApprovalCard({ track }: Props) {
  const blocked = (track.blocked_by ?? []).length > 0;
  return (
    <div className="detail">
      <div className="badge-row">
        <StateBadge state={track.state} />
        <span className={`badge ${blocked ? 'badge-yellow' : 'badge-green'}`}>
          {blocked ? `blocked by ${track.blocked_by.length} track${track.blocked_by.length === 1 ? '' : 's'}` : 'no conflicts'}
        </span>
        <span className={`badge badge-gray`}>{track.spec.risk_level} risk</span>
      </div>
      <h2 style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <RepoBadge targetRepo={track.spec.target_repo} size="large" />
        {track.title}
      </h2>
      <div className="one-line">{track.one_line}</div>

      {blocked && (
        <div className="section" style={{ background: 'var(--yellow-bg, #fef3c7)' }}>
          <h3>Blocked by</h3>
          <ul>
            {track.blocked_by.map((id) => (
              <li key={id} className="code">{id}</li>
            ))}
          </ul>
        </div>
      )}

      <PrereqBlock prereqs={track.spec.prereqs ?? []} />
      <ManifestBlock spec={track.spec} />

      <div className="section">
        <h3>Rollback</h3>
        <div className="kv">
          <strong>tag:</strong>
          <span className="code">{track.spec.rollback.git_tag}</span>
        </div>
        <div className="kv">
          <strong>side effects:</strong>
          <span>{track.spec.rollback.side_effects}</span>
        </div>
      </div>

      <div className="section">
        <h3>Success criteria</h3>
        <ul>
          {track.spec.success_criteria.map((c, i) => (
            <li key={i}>{c}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}
